import network from "../../../utils/network";
import Vue from "vue";

const urls = {
  a8: {
    mySync: "/sync/psd2/my-sync",
    start: "/sync/psd2/start",
    continue: (syncId) => `/sync/psd2/continue/${syncId}`,
    mistakeFound: "/sync/psd2/override",
    failed: (syncId) => `/sync/psd2/failed/${syncId}`,
  },
  goCardless: {
    mySync: "/sync/gocardless/psd2/my-sync",
    start: "/sync/gocardless/psd2/start",
    continue: (syncId) => `/sync/gocardless/psd2/continue/${syncId}`,
    mistakeFound: "/sync/gocardless/psd2/override",
    failed: (syncId) => `/sync/gocardless/psd2/failed/${syncId}`,
    cancel: `/sync/gocardless/psd2/cancel-my-in-progress-sync`,
  },
};

const scmsUrls = {
  banks: (locale) => `/api/psd2/content/${locale}/banks.json`,
};

const initState = () => {
  return {
    status: null,
  };
};

const actions = {
  getStatus: async ({ commit, rootGetters }, { force, flowId }) => {
    try {
      const provider = rootGetters["config/getAutoloadConfigValue"](
        "leasing_prescore_psd2_type"
      );
      let activeUrl = urls.a8.mySync;
      if (provider === "GO_CARDLESS") {
        activeUrl = urls.goCardless.mySync;
      }
      const axios = await network.connection();
      let urlParams = new URLSearchParams();
      if (force && provider !== "GO_CARDLESS") {
        urlParams.set("force", force);
      }
      if (flowId) {
        urlParams.set("flowId", flowId);
      }
      let url = `${activeUrl}?${urlParams.toString()}`;
      let { data } = await axios.get(url);
      commit("saveStatus", data);
      return data;
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
      console.debug(err);
    }
  },
  start: async ({ rootGetters }, request) => {
    try {
      const provider = rootGetters["config/getAutoloadConfigValue"](
        "leasing_prescore_psd2_type"
      );
      let activeUrl = urls.a8.start;
      if (provider === "GO_CARDLESS") {
        activeUrl = urls.goCardless.start;
      }
      const axios = await network.connection();
      let { data } = await axios.post(activeUrl, request);
      return data;
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
  continue: async ({ rootGetters }, syncId) => {
    try {
      const provider = rootGetters["config/getAutoloadConfigValue"](
        "leasing_prescore_psd2_type"
      );
      let activeUrl = urls.a8.continue;
      if (provider === "GO_CARDLESS") {
        activeUrl = urls.goCardless.continue;
      }
      const axios = await network.connection();
      let { data } = await axios.post(activeUrl(syncId));
      return data;
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
  cancel: async ({}) => {
    try {
      const axios = await network.connection();
      await axios.patch(urls.goCardless.cancel);
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
  setFailed: async ({ rootGetters }, syncId) => {
    try {
      const provider = rootGetters["config/getAutoloadConfigValue"](
        "leasing_prescore_psd2_type"
      );
      let activeUrl = urls.a8.failed;
      if (provider === "GO_CARDLESS") {
        activeUrl = urls.goCardless.failed;
      }
      const axios = await network.connection();
      let { data } = await axios.patch(activeUrl(syncId));
      return data;
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
  mistakeFound: async ({ rootGetters }, request) => {
    try {
      const provider = rootGetters["config/getAutoloadConfigValue"](
        "leasing_prescore_psd2_type"
      );
      let activeUrl = urls.a8.mistakeFound;
      if (provider === "GO_CARDLESS") {
        activeUrl = urls.goCardless.mistakeFound;
      }
      const axios = await network.connection();
      await axios.patch(activeUrl, request);
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
  getBanks: async ({}) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(
        "https://olm-scms.instacash.dev" + scmsUrls.banks("hu")
      );
      return data;
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveStatus: (state, data) => {
    Vue.set(state, "status", data);
  },
};

const getters = {
  status: (state) => {
    return state.status;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
